"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    choose: 'בחירת ',
    choose_time: 'בחירת שעה',
    choose_date: 'בחירת תאריך',
    choose_date_time: 'בחירת תאריך ושעה',
    choose_range_dates: 'בחירת טווח תאריכים'
  },
  ar: {
    choose: 'اختيار ',
    choose_time: 'اختيار الساعة',
    choose_date: 'اختيار التاريخ',
    choose_date_time: 'اختيار التاريخ والساعة',
    choose_range_dates: 'בחירת טווח תאריכים'
  },
  en: {
    choose: 'Select ',
    choose_date: 'Date Selection',
    choose_date_time: 'Date & Time Selection',
    choose_range_dates: 'Date Range Selection'
  }
};